module.exports = __webpack_public_path__ + "static/media/reporting.3bd265ce.mp4";